
<app-nav-admin--menu></app-nav-admin--menu>
<div class="configContent">
  <h1 class="configTitle">Countries</h1>

  <table class="table">
    <thead>
      <tr>
        <th class="countryNumber" scope="col" >#</th>
        <th class="countryCountry" scope="col">Country</th>
        <th class="countryDescription" scope="col">Description</th>
        <th class="countryActions" scope="col" >Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let country of countries; index as i">
        <td class="numberColumn">{{i + 1}}</td>
        <td class="nameColumn">{{country.name}}</td>
        <td>{{country.descriptionText}}</td>
        <td class="actionColumn">
          <button mat-icon-button (click)="editCountry(i)"><mat-icon>edit</mat-icon></button>
          <button mat-icon-button (click)="deleteCountry(i)"><mat-icon>delete</mat-icon></button>
        </td>
      </tr>
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td class="addCountry">
          <button mat-icon-button (click)="addCountry()"><mat-icon>add</mat-icon></button>
        </td>
      </tr>
    </tbody>
  </table>

  <hr />

  <div class="mb-5 buttonConfig">
    <button mat-raised-button class="me-2" (click)="save()" [disabled]="!dirty">Save</button>
    <button mat-raised-button (click)="discard()" [disabled]="!dirty">Discard Changes</button>
  </div>
</div>
<footer>
  <patempoFooter></patempoFooter>
</footer>
